<script>
import {cloneDeep} from 'lodash';
import axios from 'axios';
import Swal from "sweetalert2";
import {timeSince, convertToLocaleTimeString, env} from "@/state/helpers";
import ReadMore from '@/components/ReadMore';
import VueEasyLightbox from "vue-easy-lightbox";
import CommentsSection from "../CommentsSection";

export default {
  name: "AgreedContent",

  components: {
    CommentsSection,
    ReadMore,
    VueEasyLightbox
  },
  props: {
    agreedPost: {
      type: Object,
      default: () => {
      }
    }
  },

  data() {
    return {
      localAgreedPost: {},
      contentURL: '',
      description: '',
      editDescription: false,
      rows: 1,
      choosenFile: {},
      fileUploadProgress: 0,
      fileUploading: false,
      fileName: 'Choose file',
      editName: '',
      modalImageURL: '',
      showLightbox: false,
      showVideo: true,
      contentPreviewEditLink: '',
      contentPreviewEditMode: false,
      uploadFormVisible: true,
      hashTooltipText: 'Copy to Clipboard',
      contentTooltipText: 'Copy to Clipboard'

    }
  },

  computed: {
    linkIsEmpty() {
      return this.contentURL.length === 0;
    },
    showUploadAnotherButton () {
      return this.userType === 'influencer' && this.localAgreedPost.attachments.length > 0 && !this.uploadFormVisible
              && ['Not submitted', 'Draft'].includes(this.poolName);
    },
    fileNotSelected() {
      return !(this.choosenFile && this.choosenFile.name);
    },
    coverImage() {
      if (['youtube', 'blog'].includes(this.localAgreedPost.social_network)) {
        return this.localAgreedPost.content_url_preview && this.localAgreedPost.content_url_preview.image;
      } else if (this.localAgreedPost.attachments && this.localAgreedPost.attachments[0]) {
        return this.localAgreedPost.attachments[0].video_thumbnail || this.localAgreedPost.attachments[0].url;
      } else {
        return ''
      }
    },
    apiPrefix() {
      return this.userType === 'client' ? '/client' : '';
    },
    poolName() {
      const poolName = this.localAgreedPost.status.charAt(0).toUpperCase() + this.localAgreedPost.status.slice(1);
      return poolName === 'Nonsubmitted' ? 'Not submitted' : poolName;
    },
    userType() {
      return this.$store.getters['user/userType'];
    },
    fileEditingActive() {
      return this.localAgreedPost.attachments.some(item => item.editMode);
    },
    contentPreviewAvailable() {
      return this.localAgreedPost.content_url_preview && Object.keys(this.localAgreedPost.content_url_preview).length;
    }
  },

  async created() {
    this.localAgreedPost = cloneDeep(this.agreedPost);
    this.localAgreedPost.comments.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    this.description = this.localAgreedPost.content_description ? this.localAgreedPost.content_description : '';
    this.uploadFormVisible = this.localAgreedPost.attachments.length === 0;
  },
  mounted() {
    this.markNotificationsAsRead();
  },
  methods: {
    async approvePost() {
      if (await this.confirmApprove()) {
        this.$store.commit('loader/START_LOADING');
        try {
          await axios.post(`client/agreed-post/${this.localAgreedPost._id}/approve`, {});
          this.$emit('closeModal');
          this.editDescription = false;
        } finally {
          this.$store.commit('loader/END_LOADING');
        }
      }
    },
    async confirmApprove () {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: 'Back',
        confirmButtonColor: "#01baf1",
        cancelButtonColor: "#666e75",
        confirmButtonText: "Yes, approve it"
      });
      return result.value;
    },
    async sendDescription() {
      this.$store.commit('loader/START_LOADING');
      try {
        await axios.put(`/agreed-post/${this.localAgreedPost._id}/content-description`, {content_description: this.description});
        this.initialiseData();
        this.editDescription = false;
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    async updateFile(attachment) {
      this.$store.commit('loader/START_LOADING');
      try {
        await axios.put(`/agreed-post/${this.localAgreedPost._id}/attachment/${attachment._id}`, {name: this.editName});
        this.initialiseData();
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    async editAttachment(attachment) {
      this.editName = attachment.name;
      if (!this.fileEditingActive) {
        this.$set(attachment, 'editMode', true);
      }
    },
    canceleFileEdit(attachment) {
      this.$delete(attachment, 'editMode');
    },
    async removeAttachment(attachment) {
      this.$store.commit('loader/START_LOADING');
      try {
        await axios.delete(`/agreed-post/${this.localAgreedPost._id}/attachment/${attachment._id}`);
        this.initialiseData();
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    async fileChoosen(event) {
      this.choosenFile = event.target.files[0];
      this.fileName = event.target.files[0].name;
    },
    async markNotificationsAsRead() {
      try {
        await axios.post(`/notification/agreed-post/${this.localAgreedPost._id}/read`);
        await this.$store.dispatch('notifications/getTopbarNotifications');
      } catch (e) {
        // TODO
      }
    },
    async initialiseData() {
      // this.$store.commit('loader/START_LOADING');
      try {
        const {data} = await axios.get(`/agreed-post/${this.agreedPost._id}`);
        this.localAgreedPost = cloneDeep(data);
        this.localAgreedPost.comments.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

        this.$emit('agreedPostChanged', this.localAgreedPost)
      } finally {
        // this.$store.commit('loader/END_LOADING');
      }
    },
    capitaliseString(string) {
      return (string.charAt(0).toUpperCase() + string.slice(1)).replace(/_/g, " ");
    },
    convertToLocaleTimeString(date) {
      return convertToLocaleTimeString(date);
    },
    showUploadFileForm () {
      this.uploadFormVisible = true;
    },
    timeAgo(time) {
      return `${timeSince(new Date(time))} ago`;
    },
    async confirmModal() {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#01baf1",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!"
      });
      return result.value;
    },
    async sendFile() {
      let data = new FormData();
      data.append('attachment', this.choosenFile);

      let config = {
        header: {
          'Content-Type': 'image/png'
        },
        onUploadProgress: (progressEvent) => {
          this.fileUploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        }
      };
      try {
        this.fileUploading = true;
        await axios.post(`/agreed-post/${this.localAgreedPost._id}/attachment`, data, config);
        this.initialiseData();
        this.uploadFormVisible = false;
      } catch (e) {
        // TODO
      } finally {
        this.fileUploadProgress = 0;
        setTimeout(() => {
          this.fileUploading = false;
        }, 200);
      }
    },
    async sendLink() {
      this.$store.commit('loader/START_LOADING');
      try {
        await axios.post(`/agreed-post/${this.localAgreedPost._id}/content-url`, {content_url: this.contentURL});
        this.initialiseData();
        await this.getLinkPreview();
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    async getLinkPreview() {
      try {
        await axios.get(`/agreed-post/${this.localAgreedPost._id}/content-url/preview`);
        this.initialiseData();
      } catch (e) {
        // TODO
      }
    },
    previewAttachment(attachment) {
      if (['youtube', 'blog'].includes(this.localAgreedPost.social_network)) {
        window.open(this.localAgreedPost.content_url_preview.url, '_blank');
      } else if (attachment.video_thumbnail) {
        window.open(attachment.url, '_blank');
      } else {
        this.showLightbox = true;
        this.modalImageURL = attachment.url;
      }
    },
    async downloadAttachment (attachment) {
      const baseUrl = env('VUE_APP_API_URL');
      window.open(`${baseUrl}/agreed-post/${this.localAgreedPost._id}/attachment/${attachment._id}/download`, '_self', '');
    },
    closeLightbox() {
      this.showLightbox = false;
      this.modalImageURL = '';
    },
    startEditing() {
      this.contentPreviewEditMode = true;
      this.contentPreviewEditLink = this.localAgreedPost.content_url_preview.url;
    },
    cancelContentEditing() {
      this.contentPreviewEditMode = false;
      this.contentPreviewEditLink = '';
    },
    async editContentPreview() {
      this.$store.commit('loader/START_LOADING');
      try {
        await axios.put(`/agreed-post/${this.localAgreedPost._id}/content-url`, {content_url: this.contentPreviewEditLink});
        this.cancelContentEditing();
        this.initialiseData();
        await this.getLinkPreview();
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    async removeContentPreview() {
      this.$store.commit('loader/START_LOADING');
      try {
        await axios.delete(`/agreed-post/${this.localAgreedPost._id}/content-url`);
        this.initialiseData();
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    copy (text, tooltip) {
      navigator.clipboard.writeText(text);
      this[tooltip] = 'Copied!'
      setTimeout(() => this[tooltip] = 'Copy to Clipboard', 5000)
    }
  }
}
</script>

<template>
  <!--    TODO: Campaign description for influencer-->
  <!--    TODO: Clear state-->
  <!--    TODO: Youtube - influencer delete and edit attachment, after edit hit /preview again-->


  <div class="agreement-modal-content">
    <div v-if="coverImage" @click="previewAttachment(localAgreedPost.attachments[0])" class="card-top-image-container"
         :style="{ backgroundImage: `url('${coverImage}')` }">
      <span class="close-modal-x" @click.stop="$emit('closeModal')"><i class="bx bx-x"></i></span>
      <div
          v-if="localAgreedPost.attachments && localAgreedPost.attachments[0] && localAgreedPost.attachments[0].video_thumbnail"
          class="play-icon">
        <i class='bx bx-play-circle'></i>
      </div>
      <div v-if="['youtube', 'blog'].includes(localAgreedPost.social_network)" class="play-icon">
        <i class='bx bx-link-external'></i>
      </div>
    </div>
    <div class="agreement-content">
      <div class="modal-custom-header">
        <div class="d-flex align-items-center">
          <img v-if="localAgreedPost.social_network === 'instagram'"
               :src="require('@/assets/images/brands/instagram.png')" class="img-fluid header-icon" alt="">
          <img v-if="localAgreedPost.social_network === 'facebook'"
               :src="require('@/assets/images/brands/facebook.png')" class="img-fluid header-icon" alt="">
          <img v-if="localAgreedPost.social_network === 'youtube'"
               :src="require('@/assets/images/brands/youtube.png')" class="img-fluid header-icon" alt="">
          <img v-if="localAgreedPost.social_network === 'blog'"
               :src="require('@/assets/images/brands/analytics-logo.png')" class="img-fluid header-icon" alt="">
          <h4 class="mb-0 d-inline"> {{ capitaliseString(localAgreedPost.post_type) + `${localAgreedPost.giveaway ? ' - Giveaway' : ''}${localAgreedPost.event ? ' - Event' : ''}` }}</h4>
        </div>
        <span v-if="!coverImage" class="close-modal-x" @click="$emit('closeModal')"><i class="bx bx-x"></i></span>
      </div>
      <p class="mb-0 modal-subtitle text-muted">POST <span
              class="badge badge-pill font-size-12 ml-1"
              :class="{
                            'badge-soft-success': `${poolName}` === 'Approved',
                            'badge-soft-danger': `${poolName}` === 'Not submitted',
                            'badge-soft-warning': `${poolName}` === 'Draft',
                            'badge-soft-primary': `${poolName}` === 'Published'
                            }"
      >
                          {{ poolName }}
      </span></p>
      <div class="row mt-3">
        <div class="col-auto">
          <div class="row" style="max-width:180px;">
            <div class="col-12 text-muted">
              {{ userType === 'influencer' ? 'CLIENT' : 'INFLUENCER' }}
            </div>
            <div class="col-12">
              <div v-if="userType === 'influencer'" class="d-flex align-items-center my-1">
                <img v-if="localAgreedPost.client_image" class="media-object rounded-circle avatar-xs" alt
                     :src="localAgreedPost.client_image"/>
                <div v-else class="media-object avatar-xs letter-in-circle">
                  {{ localAgreedPost.client_image_alt.charAt(0) }}
                </div>
                <h5 class="font-size-13 mb-0 ml-2">{{ localAgreedPost.client_image_alt }}</h5>
              </div>
              <router-link tag="a" :to="`/client/influencers/${localAgreedPost.influencer_id}`" v-else class="d-flex align-items-center my-1">
                <img v-if="localAgreedPost.influencer_image" class="media-object rounded-circle avatar-xs" alt
                     :src="localAgreedPost.influencer_image"/>
                <div v-else class="media-object avatar-xs letter-in-circle">
                  {{ localAgreedPost.influencer_image_alt.charAt(0) }}
                </div>
                <h5 class="font-size-13 mb-0 ml-2">{{ localAgreedPost.influencer_image_alt }}</h5>
              </router-link>
            </div>
          </div>
        </div>
        <div class="col-auto">
          <div class="row" style="max-width:180px;">
            <div class="col-12 text-muted">
              CAMPAIGN NAME
            </div>
            <div class="col-12 d-flex align-items-center" style="height:2.5rem">
              <div class="d-flex align-items-center my-1">
                <h5 class="font-size-13 mb-0">{{ localAgreedPost.campaign_name }}</h5>
              </div>
            </div>
          </div>
        </div>
        <div class="col-auto">
          <div class="row" style="max-width:180px;">
            <div class="col-12 text-muted">
              PUBLISH DATE
            </div>
            <div class="col-12 d-flex align-items-center" style="height:2.5rem">
              <div class="d-flex align-items-center my-1">
                <h5 class="font-size-13 mb-0">{{ convertToLocaleTimeString(localAgreedPost.publish_date) }}</h5>
              </div>
            </div>
          </div>
        </div>
        <div v-if="localAgreedPost.social_network !== 'youtube'" class="col-auto">
          <div class="row" style="max-width:150px;">
            <div class="col-12 text-muted">
              <span class="position-relative">
                HASHTAG ID
                <span @click="copy(localAgreedPost.external_post_id, 'hashTooltipText')" class="copy-wrap" v-b-tooltip.hover.top :title="hashTooltipText">
                    <i class="mdi mdi-content-copy align-middle"></i>
                  </span>
              </span>
            </div>
            <div class="col-12 d-flex align-items-center" style="height:2.5rem">
              <div class="d-flex align-items-center my-1">
                <h5 v-if="['Approved', 'Published'].includes(poolName) && localAgreedPost.external_post_id"
                    class="font-size-13 mb-0">
                  {{ localAgreedPost.external_post_id }}
                </h5>
                <h5 v-else
                    class="font-size-13 mb-0 d-flex align-items-center">
                  <span>N/A</span>
                  <span v-b-tooltip="'Once this post is approved you\'ll get unique hashtag that you\'ll have to include in post description.'"
                        class="questionmark">
                    ?
                  </span>
                </h5>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div v-if="userType === 'client' && poolName === 'Draft'" class="row">
            <div class="col-12 text-muted text-right">
              ACTIONS
            </div>
            <div class="col-12 d-flex justify-content-end align-items-center" style="height:2.5rem">
              <button @click="approvePost" class="btn btn-primary btn-sm text-left ml-2">
                <i class="bx bx-check-circle align-middle font-size-14"></i>
                Approve post
              </button>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="modal-section">
            <div class="d-flex align-items-center justify-content-between section-heading">
              <h5 class="mb-0">Campaign description</h5>
              <div class="ml-3">
                <button
                    v-if=" userType === 'inluencer' && ['Not submitted', 'Draft'].includes(poolName) && localAgreedPost.content_description"
                    @click="editDescription = true" class="btn btn-sm btn-outline-warning"><i
                    class="bx bxs-edit-alt align-middle font-size-14"></i> <span class="align-middle">Edit</span>
                </button>
              </div>
            </div>
            <div>
              <ReadMore v-if="localAgreedPost.campaign_description"
                        :text="localAgreedPost.campaign_description"></ReadMore>
              <div v-else class="text-muted">
                No description.
              </div>
            </div>
          </div>
          <div class="modal-section">
            <div class="d-flex align-items-center justify-content-between section-heading">
              <h5 class="mb-0 position-relative">
                Content description
                <span v-if="localAgreedPost.content_description" @click="copy(localAgreedPost.content_description, 'contentTooltipText')" class="copy-wrap text-muted" v-b-tooltip.hover.top :title="contentTooltipText">
                    <i class="mdi mdi-content-copy align-middle"></i>
                  </span>
              </h5>
              <div class="ml-3">
                <button
                    v-if=" userType === 'inluencer' && ['Not submitted', 'Draft'].includes(poolName) && localAgreedPost.content_description"
                    @click="editDescription = true" class="btn btn-sm btn-outline-warning"><i
                    class="bx bxs-edit-alt align-middle font-size-14"></i> <span class="align-middle">Edit</span>
                </button>
              </div>
            </div>
            <div
                v-if="userType === 'influencer' && (['Not submitted', 'Draft'].includes(poolName) && !localAgreedPost.content_description) || editDescription">
              <label>Write a post description:</label>
              <textarea-autosize
                  class="form-control"
                  placeholder="Write a description..."
                  v-model="description"
                  :min-height="60"
                  :max-height="350"/>
              <button @click="editDescription = false" class="btn btn-light btn-sm mt-2 mr-2"> Cancel</button>
              <button @click="sendDescription" :disabled="this.description === ''" class="btn btn-primary btn-sm mt-2">
                Save
              </button>
            </div>
            <div v-else>
              <ReadMore v-if="localAgreedPost.content_description"
                        :text="localAgreedPost.content_description"></ReadMore>
              <div v-else class="text-muted">
                No description.
              </div>
            </div>
          </div>
          <div class="modal-section">
            <div class="d-flex align-items-center justify-content-between section-heading">
              <h5 class="mb-0">Attachments</h5>
            </div>
            <div v-if="['facebook', 'instagram'].includes(localAgreedPost.social_network)">
              <div v-for="attachment in localAgreedPost.attachments" :key="attachment._id" class="post-attachment mb-2">
                <div @click="previewAttachment(attachment)" class="attachment-thumbnail has-pointer-cursor">
                  <div v-if="attachment.video_thumbnail" class="play-icon-sm">
                    <i class='bx bx-play-circle'></i>
                  </div>
                  <img :src="attachment.video_thumbnail || attachment.url" class="img-fluid" alt="">
                </div>
                <div class="col attachment-body">
                  <b-input @click.stop v-if="attachment.editMode" v-model="editName" class="form-control-sm"></b-input>
                  <h6 v-else class="mb-1 has-pointer-cursor">{{ attachment.name }}</h6>
                  <div v-if="!attachment.editMode" class="attachment-meta font-size-12">
                    <span class="text-muted"> Added {{ timeAgo(attachment.created_at) }}</span>
                    <span v-if="userType === 'influencer' && ['Not submitted', 'Draft'].includes(poolName)"
                          class="attachment-acitons">
                                            <span @click.stop="editAttachment(attachment)"
                                                  class="text-muted ml-2 comment-link">Edit</span>
                                            <span @click.stop="removeAttachment(attachment)"
                                                  class="text-muted ml-2 comment-link">Delete</span>
                                          </span>
                    <span class="attachment-acitons">
                      <span @click="previewAttachment(attachment)"
                            class="text-muted ml-2 comment-link">Preview</span>
                      <span @click="downloadAttachment(attachment)"
                            class="text-muted ml-2 comment-link">Download</span>
                    </span>
                  </div>
                  <div v-else>
                    <a @click.stop="canceleFileEdit(attachment)" class="btn btn-sm btn-light mt-2 mr-2">Cancel</a>
                    <a @click.stop="updateFile(attachment)" class="btn btn-sm btn-primary mt-2 mr-2">Save</a>
                  </div>
                  <div class="attachment-description">

                  </div>
                </div>
              </div>
              <div v-if="fileUploading" class="mb-2 d-flex">
                <div class="attachment-thumbnail">

                </div>
                <div class="col">
                  <h6 class="mb-3">{{ fileName }}</h6>
                  <div class="attachment-description">
                    <b-progress :value="fileUploadProgress" :max="100" class="mb-4"></b-progress>
                  </div>
                </div>
              </div>
              <div v-if="localAgreedPost.attachments.length === 0" class="text-muted">
                No attachments.
              </div>
              <div v-if="userType === 'influencer' && ['Not submitted', 'Draft'].includes(poolName) && !showUploadAnotherButton"
                   class="select-file">
                <label class="mt-2">Select file you want to upload:</label>
                <div class="custom-file">
                  <input id="customFile" type="file" class="custom-file-input" @change="fileChoosen($event)"/>
                  <label class="custom-file-label" for="customFile">{{ fileName }}</label>
                  <button @click="sendFile" :disabled="fileNotSelected" class="btn btn-primary btn-sm mt-2"> Upload file
                  </button>
                </div>
              </div>
              <button v-if="showUploadAnotherButton" @click="showUploadFileForm" class="btn btn-light btn-sm mt-2"> + Add new file </button>
            </div>
            <div v-else>
              <div v-if="contentPreviewAvailable" @click="previewAttachment" class="post-attachment mb-2">
                <div class="attachment-thumbnail has-pointer-cursor">
                  <div class="play-icon-sm">
                    <i class='bx bx-link-external'></i>
                  </div>
                  <img :src="localAgreedPost.content_url_preview.image" class="img-fluid" alt="">
                </div>
                <div class="col attachment-body">
                  <div v-if="contentPreviewEditMode">
                    <b-input @click.stop v-model="contentPreviewEditLink" class="form-control-sm"></b-input>
                    <a @click.stop="cancelContentEditing" class="btn btn-sm btn-light mt-2 mr-2">Cancel</a>
                    <a @click.stop="editContentPreview" class="btn btn-sm btn-primary mt-2 mr-2">Save</a>
                  </div>
                  <h6 v-else class="mb-0 has-pointer-cursor"> {{ localAgreedPost.content_url_preview.title }} </h6>
                  <div class="attachment-meta font-size-12 mb-2">
                    <span class="text-muted"> Added {{ timeAgo(localAgreedPost.content_url_preview_created_at) }}</span>
                    <span v-if="userType === 'influencer' && ['Not submitted', 'Draft'].includes(poolName)"
                          class="attachment-acitons">
                                            <span @click.stop="startEditing"
                                                  class="text-muted ml-2 comment-link">Edit</span>
                                            <span @click.stop="removeContentPreview"
                                                  class="text-muted ml-2 comment-link">Delete</span>
                                        </span>
                  </div>
                  <read-more :max="60" :text="localAgreedPost.content_url_preview.description"></read-more>
                </div>
              </div>
              <div v-else-if="userType === 'influencer'">
                Provide a link to the
                {{ localAgreedPost.social_network === 'youtube' ? 'Youtube video' : 'Blog post page' }}:
                <div class="mt-2">
                  <b-input type="text" v-model="contentURL" placeholder="Enter URL..."/>
                </div>
                <button @click="sendLink" :disabled="linkIsEmpty" class="btn btn-primary btn-sm mt-2">Upload link
                </button>
              </div>
              <div v-else class="text-muted">
                No attachments.
              </div>
            </div>
          </div>

          <CommentsSection :cardData="localAgreedPost" card-type="agreed-post" @updated="initialiseData" />

        </div>
      </div>
    </div>

    <!--        lightbox for dispalying images-->
    <vue-easy-lightbox
        :visible="showLightbox"
        :imgs="modalImageURL"
        @hide="closeLightbox"
    ></vue-easy-lightbox>

  </div>
</template>

<style scoped>
.header-icon {
  max-width: 30px;
  margin-right: 15px;
}

.tab-section h5 {
  font-size: 0.9rem;
}

.social-image-container img {
  width: 22px;
}

textarea {
  resize: none;
}

.modal-subtitle {
  margin-top: 5px;
  font-size: 1em;
}

.modal-custom-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pool-name {
  text-decoration: underline;
}

.comment-link {
  cursor: pointer;
  text-decoration: underline !important;
}

.card-top-image-container {
  position: relative;
  background-color: #dce7f1;
  border-radius: 0.5rem 0.5rem 0px 0px;
  height: 220px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  cursor: pointer;
}

.agreement-content {
  padding: 1.5em;
}

.attachment-thumbnail {
  position: relative;
  height: 80px;
  width: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #dce7f1;
}

.attachment-thumbnail img {
  max-height: 80px;
}

.play-icon {
  position: absolute;
  left: calc(50% - 30px);
  top: calc(50% - 30px);
  border-radius: 50%;
  height: 60px;
  width: 60px;
  z-index: 1000;
}

.play-icon i {
  font-size: 60px;
  color: rgba(255, 255, 255, 0.5);
}

.play-icon-sm {
  position: absolute;
  left: calc(50% - 20px);
  top: calc(50% - 20px);
  border-radius: 50%;
  height: 40px;
  width: 40px;
  z-index: 1000;
}

.play-icon-sm i {
  font-size: 40px;
  color: rgba(255, 255, 255, 0.5);
}

.questionmark {
  display: inline-block;
  background-color: #d5d5d5;
  margin-left: 7px;
  padding-left: 5px;
  padding-top: 3px;
  width: 16px;
  height: 16px;
  font-size: 10px;
  border-radius: 50%;
  cursor: pointer;
}

  .copy-wrap {
    position: absolute;
    padding: 5px 0 0 0;
    font-size: 14px;
    text-align: center;
    right: -40px;
    line-height: 18px;
    top: -6px;
    display: inline-block;
    width: 30px;
    height: 30px;
    cursor: pointer;
    border-radius: 50%;
    background-color: rgba(0,0,0,0.05)
  }
  .copy-wrap:hover {
    background-color: rgba(0,0,0,0.1)
  }
</style>
